module.exports = __webpack_public_path__ + "img/empw-letters.bb6576e5.png";